import { render, staticRenderFns } from "./DialogoRelatorioAnualDRE.vue?vue&type=template&id=e281e054&scoped=true&"
import script from "./DialogoRelatorioAnualDRE.vue?vue&type=script&lang=js&"
export * from "./DialogoRelatorioAnualDRE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e281e054",
  null
  
)

export default component.exports